// UserBbsInfoGql.js
import { gql } from "@apollo/client";

const USER_BBS_INFO_LIST_PART = gql`
fragment UserBbsInfoListPart on UserBbsInfo {
    bbsInfoSeq
    email
    userBbsCatCd
    userBbsCat
    userBbsStatusCd
    userBbsStatus
    title
    readCnt
    markup
    topOrder
    fileAddr
    fileName1
    fileName2
    fileName3
    fileName4
    fileName5
    dscId
    dscName
    regUserId
    regUserName
    regTime
    updateUserId
    updateUserName
    updateTime
}
`;

const USER_BBS_INFO_NO_LIST_PART = gql`
fragment UserBbsInfoNoListPart on UserBbsInfo {
    content
}
`;


const USER_BBS_COMMENTS_PART = gql`
fragment UserBbsCommentsPart on UserBbsComments {
    cmtId
    bbsInfoSeq
    content
    regUserId
    regUserName
    regTime
    updateUserId
    updateUserName
    updateTime
}
`;


export const LIST_USER_BBS_INFO = gql`
${USER_BBS_INFO_LIST_PART}
query ListUserBbsInfo($dateFrom:String, $dateTill:String) {
    userBbsInfoList(dateFrom:$dateFrom, dateTill:$dateTill) {
        ...UserBbsInfoListPart
    }
}
`;

export const GET_USER_BBS_INFO = gql`
${USER_BBS_INFO_LIST_PART}
${USER_BBS_INFO_NO_LIST_PART}
${USER_BBS_COMMENTS_PART}
query GetUserBbsInfo($bbsInfoSeq:Long!) {
    userBbsInfoItem(bbsInfoSeq:$bbsInfoSeq) {
        userBbsInfo {
            ...UserBbsInfoListPart
            ...UserBbsInfoNoListPart
        }
        comments {
            ...UserBbsCommentsPart
        }
    }
}
`;

export const ADD_USER_BBS_INFO = gql`
mutation AddUserBbsInfo($userBbsInfo:InputUserBbsInfoAdd!) {
  userBbsInfoAdd(userBbsInfo: $userBbsInfo) {
    ok
    message
    item {
        bbsInfoSeq
    }
  }
}
`;

export const EDIT_USER_BBS_INFO = gql`
mutation EditUserBbsInfo($userBbsInfo:InputUserBbsInfoEdit!) {
  userBbsInfoEdit(userBbsInfo: $userBbsInfo) {
    ok
    message
  }
}
`;

export const REMOVE_USER_BBS_INFO = gql`
mutation RemoveUserBbsInfo($userBbsInfo:InputUserBbsInfoRemove!) {
  userBbsInfoRemove(userBbsInfo: $userBbsInfo) {
    ok
    message
  }
}
`;

export const SET_USER_BBS_INFO_STATUS = gql`
mutation SetUserBbsInfoStatus($bbsInfoSeq:Long!, $userBbsStatusCd:String!) {
    userBbsInfoSetStatus(bbsInfoSeq:$bbsInfoSeq, userBbsStatusCd:$userBbsStatusCd) {
        ok
        message
    }
}
`;

export const LIST_USER_BBS_COMMENTS = gql`
${USER_BBS_COMMENTS_PART}
query ListUserBbsComments($bbsInfoSeq:Long!) {
    userBbsCommentsList(bbsInfoSeq:$bbsInfoSeq) {
        ...UserBbsCommentsPart
    }
}
`;

export const GET_USER_BBS_COMMENTS = gql`
${USER_BBS_COMMENTS_PART}
query GetUserBbsComments($cmtId:Long) {
    userBbsCommentsItem(cmtId:$cmtId) {
        ...UserBbsCommentsPart
    }
}
`;

export const ADD_USER_BBS_COMMENTS = gql`
${USER_BBS_COMMENTS_PART}
mutation AddUserBbsComments($userBbsComments:InputUserBbsCommentsAdd!) {
  userBbsCommentsAdd(userBbsComments: $userBbsComments) {
    ok
    message
    list {
        ...UserBbsCommentsPart
    }
  }
}
`;

export const EDIT_USER_BBS_COMMENTS = gql`
${USER_BBS_COMMENTS_PART}
mutation EditUserBbsComments($userBbsComments:InputUserBbsCommentsEdit!) {
  userBbsCommentsEdit(userBbsComments: $userBbsComments) {
    ok
    message
    list {
        ...UserBbsCommentsPart
    }
  }
}
`;

export const REMOVE_USER_BBS_COMMENTS = gql`
${USER_BBS_COMMENTS_PART}
mutation RemoveUserBbsComments($userBbsComments:InputUserBbsCommentsRemove!) {
  userBbsCommentsRemove(userBbsComments: $userBbsComments) {
    ok
    message
    list {
        ...UserBbsCommentsPart
    }
  }
}
`;

// 첨부파일 다운로드용 PreSigned URL 발급
export const GET_USER_BBS_INFO_DOWNLOAD_URL_PRE_SIGNED = gql`
query GetUserBbsInfoDownloadUrlPreSigned($bbsInfoSeq: Long!, $fileId: Int!) {
    userBbsInfoGetDownloadUrlPreSigned(bbsInfoSeq: $bbsInfoSeq, fileId: $fileId) {
        preSignedUrl
        objectKey
    }
}
`;

// 첨부파일 업로드용 PreSigned URL 발급
export const GET_USER_BBS_INFO_UPLOAD_URL_PRE_SIGNED = gql`
query GetUserBbsInfoUploadUrlPreSigned($bbsInfoSeq: Long!, $filename: String!, $contentType: String!) {
    userBbsInfoGetUploadUrlPreSigned(bbsInfoSeq: $bbsInfoSeq, filename: $filename, contentType: $contentType) {
        preSignedUrl
        objectKey
    }
}
`;

// userBbsInfoGetUploadUrlPreSigned 사용해서 S3 첨부파일 올린 후 DB 기록.
export const ADD_USER_BBS_INFO_FILE = gql`
mutation AddUserBbsInfoFile($userBbsInfo: InputUserBbsInfoAddFile!) {
    userBbsInfoAddFile(userBbsInfo: $userBbsInfo) {
        ok
        message
    }
}
`;

// 첨부 파일 삭제
export const REMOVE_USER_BBS_INFO_FILE = gql`
mutation RemoveUserBbsInfoFile($userBbsInfo: InputUserBbsInfoFileItem!) {
    userBbsInfoRemoveFile(userBbsInfo: $userBbsInfo) {
        ok
        message
    }
}
`;


/*
# user_bbs_info.graphqls
# user_bbs_info and user_bbs_comments together.

extend type Query {
	userBbsInfoList(dateFrom:String,dateTill:String): [UserBbsInfo]!
	userBbsInfoItem(bbsInfoSeq:Long!): UserBbsInfoAndComments
    userBbsInfoGetDownloadUrlPreSigned(bbsInfoSeq: Long!, fileId: Int!): S3Url
    userBbsInfoGetUploadUrlPreSigned(bbsInfoSeq: Long!, filename: String!, contentType: String!): S3Url
	userBbsCommentsList(bbsInfoSeq:Long!): [UserBbsComments]!
	userBbsCommentsItem(cmtId:Long!): UserBbsComments
}

extend type Mutation {
	userBbsInfoAdd(userBbsInfo: InputUserBbsInfoAdd!): ResponseWithUserBbsInfo
	userBbsInfoEdit(userBbsInfo: InputUserBbsInfoEdit!): CommonResponse
    userBbsInfoSetStatus(bbsInfoSeq: Long!, userBbsStatusCd: String!): CommonResponse
	userBbsInfoRemove(userBbsInfo: InputUserBbsInfoRemove!): CommonResponse
    userBbsInfoAddFile(userBbsInfo: InputUserBbsInfoAddFile!): CommonResponse
    userBbsInfoRemoveFile(userBbsInfo: InputUserBbsInfoFileItem!): CommonResponse
	userBbsCommentsAdd(userBbsComments: InputUserBbsCommentsAdd!): ResponseWithUserBbsCommentsList
	userBbsCommentsEdit(userBbsComments: InputUserBbsCommentsEdit!): ResponseWithUserBbsCommentsList
	userBbsCommentsRemove(userBbsComments: InputUserBbsCommentsRemove!): ResponseWithUserBbsCommentsList
}

type UserBbsInfo {
	bbsInfoSeq: Long!
	title: String!
	content: String!
	email: String
	userBbsCatCd: String!
    userBbsCat: String
	userBbsStatusCd: String!
    userBbsStatus: String
	readCnt: Int
	markup: Boolean
	topOrder: Boolean
	fileAddr: String
	fileName1: String
	fileName2: String
	fileName3: String
	fileName4: String
	fileName5: String
	regUserId: String
	regUserName: String
	regTime: String
	updateUserId: String
	updateUserName: String
	updateTime: String
}

input InputUserBbsInfoAdd {
	title: String!
	content: String!
	email: String
	userBbsCatCd: String
	markup: Boolean
	topOrder: Boolean
}

input InputUserBbsInfoEdit {
	bbsInfoSeq: Long!
	title: String!
	content: String!
	email: String
	userBbsCatCd: String
	markup: Boolean
	topOrder: Boolean
}

input InputUserBbsInfoRemove {
	bbsInfoSeq: Long!
}

type ResponseWithUserBbsInfo {
    ok: Boolean!
    message: String
    item: UserBbsInfo
}

input InputUserBbsInfoAddFile {
    bbsInfoSeq: Long!
    fileId: Int!
    fileName1: String!
}

input InputUserBbsInfoFileItem {
    bbsInfoSeq: Long!
    fileId: Int!
}

# for userBbsComments
type UserBbsComments {
	cmtId: Long!
	bbsInfoSeq: Long!
	content: String!
	regUserId: String
	regUserName: String
	regTime: String
	updateUserId: String
	updateUserName: String
	updateTime: String
}

input InputUserBbsCommentsAdd {
	bbsInfoSeq: Long!
	content: String!
}

input InputUserBbsCommentsEdit {
	cmtId: Long!
	bbsInfoSeq: Long!
	content: String!
}

input InputUserBbsCommentsRemove {
	cmtId: Long!
	bbsInfoSeq: Long!
}

# for userBbsInfoItem
type UserBbsInfoAndComments {
    userBbsInfo: UserBbsInfo
    comments: [UserBbsComments]
}

# for userBbsCommentsAdd, userBbsCommentsEdit, userBbsCommentsRemove
type ResponseWithUserBbsCommentsList {
    ok: Boolean!
    message: String
    list: [UserBbsComments]
}

# for userBbsInfoSetStatus
#type ResponseWithUserBbsInfoAndComments {
#    ok: Boolean!
#    message: String
#    item: UserBbsInfoAndComments
#}

*/